import { Container, Row, Col } from 'react-bootstrap';
import Plot from 'react-plotly.js';
import { ThreeDots } from 'react-loader-spinner';

function SpectraPlot(props) {
	const loading = props.isLoading;

	return (
		<>
			{loading ? (
				<Container className='text-center'>
					<Row>
						<Col
							style={{
								display: 'flex',
								justifyContent: 'center',
							}}
						>
							<ThreeDots color='rgba(0,173,181,1)' height={80} width={80} />
						</Col>
					</Row>
				</Container>
			) : (
				<Container>
					<div style={{ textAlign: 'center' }}>
						<Plot
							data={[
								{
									x: props.wavelengths,
									y: props.upperLeft,
									type: 'scatter',
									mode: 'lines',
									marker: { color: 'blue' },
									name: 'Upper Left',
								},
								{
									x: props.wavelengths,
									y: props.upperRight,
									type: 'scatter',
									mode: 'lines',
									marker: { color: 'red' },
									name: 'Upper Right',
								},

								{
									x: props.wavelengths,
									y: props.centre,
									type: 'scatter',
									mode: 'lines',
									marker: { color: 'purple' },
									name: 'Centre',
								},
								{
									x: props.wavelengths,
									y: props.lowerLeft,
									type: 'scatter',
									mode: 'lines',
									marker: { color: 'yellow' },
									name: 'Lower Left',
								},
								{
									x: props.wavelengths,
									y: props.lowerRight,
									type: 'scatter',
									mode: 'lines',
									marker: { color: 'green' },
									name: 'Lower Right',
								},
							]}
							layout={{
								responsive: true,
							}}
							useResizeHandler={true}
							style={{ width: '100%', height: '100%' }}
						/>
					</div>
				</Container>
			)}
		</>
	);
}

export default SpectraPlot;
